import React from "react";


const styles = {
    container: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        backgroundColor: "#fff",
        color: "#000",
        height: "100vh",
        textAlign: "center",
    },
    text: {
        fontSize: "3rem",
    },
    smallText: {
        fontSize: "1.5rem",
    },
    button: {
        cursor: "pointer",
        border: "2px solid #000",
        borderRadius: "5px",
        padding: "0.5em",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
}

const ErrorFallback = () => {

    const goBack = () => {
        setTimeout(() => window.history.back(), 1000)
    }
    return (
        <>
            <div style={styles.container}>
                <p style={styles.text}>Looks Like an issue here</p>
                <div onClick={goBack} style={styles.button}>
                    <span style={styles.smallText}>Go Back</span>
                </div>
            </div>
        </>
    )
}

export default ErrorFallback;